/**
 * Вызывает указанный метод у счётчиков с counterIds, если они
 * присутствуют в window.
 *
 * @param {number|string|number[]|string[]} counterIds - один или несколько id счётчиков (только цифры)
 * @param {string} [methodName=reachGoal] - имя метода, который нужно вызвать
 * @param {...*} methodParams - параметры вызова метода ([доки](https://yandex.ru/support/metrika/objects/method-reference.html))
 */
export function callYaMetrikaMethod(counterIds, methodName = 'reachGoal', ...methodParams) {
  if (!counterIds || !window.ym) return;

  [].concat(counterIds).forEach(counter => {
    const id = counter.id || counter;
    id && window.ym(id, methodName, ...methodParams);
  });
}
